import FullPageLoader from '@components/core/full-page-loader/full-page-loader';
import { PageLoadError } from '@components/page-load-error';
import { getGoalsQueryOptions } from '@features/goals/api/get-goals';
import { getCobrandQueryOptions } from '@features/navigation/api/get-cobrand';
import {
  BetaFeaturesEnum,
  getBetaFeaturesQueryOptions,
} from '@src/api/beta-features/get-beta-features';
import GoalsLayout from '@src/routes/_authenticated/goals/-goals-layout';
import { useThemeStore } from '@src/stores/theme-store';
import { GetCobrandResponse } from '@src/types/get-cobrand-response';
import { createFileRoute, redirect } from '@tanstack/react-router';
import React from 'react';

export const Route = createFileRoute('/_authenticated/goals/')({
  component: GoalsLayout,
  errorComponent: ({ error }) => (
    <PageLoadError pageName='Goals' error={error} />
  ),
  beforeLoad: ({ context }) => {
    const data = context.queryClient.getQueryData(
      getBetaFeaturesQueryOptions.queryKey,
    );
    const airMaxEnabled = data?.find(
      ([key]) => key === BetaFeaturesEnum.AIR_MAX,
    )?.[1];

    if (!airMaxEnabled) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        href: `${import.meta.env.VITE_BASE_URL}/performance-report#personal-goals`,
      });
    }
  },
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(getGoalsQueryOptions);
  },
  wrapInSuspense: true,
  pendingComponent: () => {
    const partner = useThemeStore.use.partner();
    const data: GetCobrandResponse | undefined =
      Route.useRouteContext().queryClient.getQueryData(
        getCobrandQueryOptions({ partner }).queryKey,
      );
    return <FullPageLoader cobrandImage={data?.image} />;
  },
});
